import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { LogOut } from 'lucide-react';

/**
 * Footer de navigation avec profil utilisateur
 * Composant séparé pour une meilleure organisation
 */

interface NavigationFooterProps {
  onSignOut?: () => Promise<void>;
}

export function NavigationFooter({ onSignOut }: NavigationFooterProps) {
  const { user, signOut } = useAuth();

  const handleSignOut = async () => {
    if (onSignOut) {
      await onSignOut();
    } else {
      await signOut();
    }
  };

  const displayName = user?.email?.split('@')[0] || 'Utilisateur';
  const userInitial = user?.email?.charAt(0).toUpperCase() || 'U';

  return (
    <footer className="flex items-center justify-between w-full">
      <div className="flex gap-1.5 items-center min-w-0 flex-1">
        <div className="bg-white rounded-md w-9 h-9 flex items-center justify-center overflow-hidden shadow-sm shrink-0">
          <div className="w-8 h-8 bg-zinc-300 rounded-full flex items-center justify-center text-zinc-600 text-sm font-semibold">
            {userInitial}
          </div>
        </div>
        <div className="flex flex-col gap-0.5 min-w-0 flex-1">
          <span
            className="text-sm font-semibold leading-none text-zinc-700 overflow-hidden text-ellipsis"
            title={displayName}
          >
            {displayName}
          </span>
          <span
            className="text-xs font-normal leading-none text-zinc-700 overflow-hidden text-ellipsis"
            title={user?.email || 'user@example.com'}
          >
            {user?.email || 'user@example.com'}
          </span>
        </div>
      </div>

      <Button
        variant="ghost"
        size="sm"
        onClick={handleSignOut}
        className="w-8 h-8 p-0 hover:bg-zinc-100 shrink-0"
        aria-label="Se déconnecter"
      >
        <LogOut className="w-4 h-4" />
      </Button>
    </footer>
  );
}
